import React from 'react';
import { TrendingUpIcon, UsersIcon, TargetIcon, ZapIcon } from 'lucide-react';
const examples = [{
  icon: TrendingUpIcon,
  title: '+1,200 alumnas',
  description: 'Generando ingresos reales con tabletas aromáticas'
}, {
  icon: UsersIcon,
  title: 'Recuperá inversión',
  description: 'Con la venta de tus primeras 3-4 tabletas'
}, {
  icon: TargetIcon,
  title: 'Producto rentable',
  description: 'Márgenes de ganancia excelentes'
}, {
  icon: ZapIcon,
  title: 'En 24 horas',
  description: 'De principiante a vendiendo tus primeras tabletas'
}];
export function SocialProofSection() {
  return <section className="bg-white py-16 md:py-20 px-4" data-id="element-403">
      <div className="container mx-auto max-w-6xl" data-id="element-404">
        <div className="text-center mb-12" data-id="element-405">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-406">
            Resultados que hablan por sí solos
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto" data-id="element-407">
            Miles de mujeres ya están generando ingresos con tabletas aromáticas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-408">
          {examples.map((example, index) => {
          const Icon = example.icon;
          return <article key={index} className="backdrop-blur-sm bg-white/80 rounded-2xl border border-white/20 shadow-sm p-6 hover:shadow-md transition-shadow duration-300" data-id="element-409">
                <div className="w-12 h-12 bg-gradient-to-br from-[#FFD6EC] to-[#FFB3E6] rounded-xl flex items-center justify-center mb-4" data-id="element-410">
                  <Icon className="w-6 h-6 text-[#FF4DB8]" aria-hidden="true" data-id="element-411" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-412">
                  {example.title}
                </h3>
                <p className="text-[#6B6B6B]" data-id="element-413">{example.description}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}